import Swiper from "swiper";
/**
 * Slider
 * @constructor
 */
class Slider {
  constructor() {}
  /**
   * コモン
   */
  init() {
    
    
    var pc = window.matchMedia("(min-width: 768px)").matches;
    var sp = window.matchMedia("(max-width: 767px)").matches;
  
    //ページ下部のスライダー制御（swiper）
    new Swiper('.swiper-container-common', {
      loop: true,
      speed: 500,
      centeredSlides: true,
      slidesPerView: '3',
      spaceBetween: 15,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      // 751px以上の場合
      breakpoints: {
        750: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
      },
    })
    
    if(sp) {
      new Swiper('.swiper-container-page-link', {
        loop: false,
        speed: 300,
        initialSlide: 0,
        slidesPerView: 'auto',
        freeModeSticky: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      })
    }
    
    
    if(sp) {
      var path = location.pathname
      new Swiper('.swiper-container-page-list', {
        loop: false,
        speed: 300,
        initialSlide: 0,
        slidesPerView: 'auto',
        freeModeSticky: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }        
      })
      if (path == "/corporate/about/") {
        $('.swiper-slide--01').css('font-weight','bold');
        new Swiper('.swiper-container-page-list', {
          loop: false,
          speed: 300,
          initialSlide: 0,
          slidesPerView: 'auto',
          freeModeSticky: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        })
      }
      if (path == "/corporate/about/history/") {
        $('.swiper-slide--02').css('font-weight','bold');
        new Swiper('.swiper-container-page-list', {
          loop: false,
          speed: 300,
          initialSlide: 1,
          slidesPerView: 'auto',
          freeModeSticky: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        })
      }
      if (path == "/corporate/about/group/") {
        $('.swiper-slide--03').css('font-weight','bold');
        new Swiper('.swiper-container-page-list', {
          loop: false,
          speed: 300,
          initialSlide: 2,
          slidesPerView: 'auto',
          freeModeSticky: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        })
      }
      if (path == "/corporate/about/certification/") {
        $('.swiper-slide--04').css('font-weight','bold');
        new Swiper('.swiper-container-page-list', {
          loop: false,
          speed: 300,
          initialSlide: 3,
          slidesPerView: 'auto',
          freeModeSticky: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        })
      }
      if (path == "/corporate/sustainability/") {
        $('.swiper-slide--01').css('font-weight','bold');
        new Swiper('.swiper-container-page-list', {
          loop: false,
          speed: 300,
          initialSlide: 0,
          slidesPerView: 'auto',
          freeModeSticky: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        })
      }
      if (path == "/corporate/sustainability/compliance/") {
        $('.swiper-slide--02').css('font-weight','bold');
        new Swiper('.swiper-container-page-list', {
          loop: false,
          speed: 300,
          initialSlide: 1,
          slidesPerView: 'auto',
          freeModeSticky: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        })
      }
      if (path == "/corporate/sustainability/sdgs/") {
        $('.swiper-slide--03').css('font-weight','bold');
        new Swiper('.swiper-container-page-list', {
          loop: false,
          speed: 300,
          initialSlide: 2,
          slidesPerView: 'auto',
          freeModeSticky: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        })
      }
      if (document.URL.match('/corporate/sustainability/sponsor/')) {
        $('.swiper-slide--04').css('font-weight','bold');
        new Swiper('.swiper-container-page-list', {
          loop: false,
          speed: 300,
          initialSlide: 3,
          slidesPerView: 'auto',
          freeModeSticky: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        })
      }
      if (path == "/corporate/sustainability/raiserz/") {
        $('.swiper-slide--05').css('font-weight','bold');
        new Swiper('.swiper-container-page-list', {
          loop: false,
          speed: 300,
          initialSlide: 4,
          slidesPerView: 'auto',
          freeModeSticky: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        })
      }

      // 以下英語版の記述
      if (path == "/en/about/") {
        $('.swiper-slide--en01').css('font-weight','bold');
        new Swiper('.swiper-container-page-list', {
          loop: false,
          speed: 300,
          initialSlide: 0,
          slidesPerView: 'auto',
          freeModeSticky: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        })
      }

      if (path == "/en/about/history/") {
        $('.swiper-slide--en02').css('font-weight','bold');
        new Swiper('.swiper-container-page-list', {
          loop: false,
          speed: 300,
          initialSlide: 1,
          slidesPerView: 'auto',
          freeModeSticky: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        })
      }

      if (path == "/en/about/group/") {
        $('.swiper-slide--en03').css('font-weight','bold');
        new Swiper('.swiper-container-page-list', {
          loop: false,
          speed: 300,
          initialSlide: 2,
          slidesPerView: 'auto',
          freeModeSticky: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        })
      }

    }
  }
}

export default Slider;